<template>
	<div class="game-rating">
		<!-- Show ESRB logo for North America & South America -->
		<div v-if="esrbRegions.indexOf(countryCode) > -1" :class="`game-rating__esrb-${formatedGameName}`"></div>

		<!-- Show PEGI Logo for Europe exclude DE for Germany -->
		<div v-if="pegiRegions.indexOf(countryCode) > -1 && countryCode !== 'DE'" :class="`game-rating__pegi-${formatedGameName}`"></div>

		<!-- Show USK Logo for Germany -->
		<div v-if="countryCode === 'DE'" :class="`game-rating__usk-${formatedGameName}`"></div>

		<!-- Show ACB Logo for Oceania -->
		<!-- <div v-if="Oceania.indexOf(countryCode) > -1" :class="`game-rating__acb-${formatedGameName}`"></div> -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
	name: 'GameRating',
	props: {
		gameName: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			NorthAmerica: [
				'AI',
				'AG',
				'AW',
				'BS',
				'BB',
				'BZ',
				'BM',
				'BQ',
				'VG',
				'CA',
				'KY',
				'CR',
				'CU',
				'CW',
				'DM',
				'DO',
				'SV',
				'GL',
				'GD',
				'GP',
				'GT',
				'HT',
				'HN',
				'JM',
				'MQ',
				'MX',
				'PM',
				'MS',
				'CW',
				'KN',
				'NI',
				'PA',
				'PR',
				'BQ',
				'BQ',
				'SX',
				'KN',
				'LC',
				'PM',
				'VC',
				'TT',
				'TC',
				'US',
				'VI',
			],
			SouthAmerica: ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF', 'GY', 'GY', 'PY', 'PE', 'SR', 'UY', 'VE'],
			Europe: [
				'AL',
				'AD',
				'AT',
				'BY',
				'BE',
				'BA',
				'BG',
				'HR',
				'CY',
				'CZ',
				'DK',
				'EE',
				'FO',
				'FI',
				'FR',
				'DE',
				'GI',
				'GR',
				'HU',
				'IS',
				'IE',
				'IT',
				'LV',
				'LI',
				'LT',
				'LU',
				'MK',
				'MT',
				'MD',
				'MC',
				'NL',
				'NO',
				'PL',
				'PT',
				'RO',
				'RU',
				'SM',
				'RS',
				'SK',
				'SI',
				'ES',
				'SE',
				'CH',
				'UA',
				'GB',
				'VA',
				'RS',
				'IM',
				'RS',
				'ME',
			],
			// Oceania: ['AU', 'NZ'],
		};
	},
	computed: {
		...mapState(['countryInfo']),
		esrbRegions() {
			return this.NorthAmerica.concat(this.SouthAmerica);
		},
		pegiRegions() {
			return this.Europe;
		},
		countryCode() {
			return this.countryInfo.country;
		},
		formatedGameName() {
			return this.gameName.replace(/[ :]+/g, '-').toLowerCase();
		},
	},
	async created() {
		await this.checkCountryInfo();
	},
	methods: {
		...mapActions(['checkCountryInfo']),
	},
};
</script>

<style lang="less">
.game-rating {
	color: white;
	.game-rating__esrb-kartrider-drift {
		background: url(../../images/game-rating/esrb-e.png) no-repeat center center / contain;
		margin-top: 20px;
		height: 95px;
		width: 63px;
	}
	.game-rating__pegi-kartrider-drift {
		background: url(../../images/game-rating/pegi-3.png) no-repeat center center / contain;
		margin-top: 20px;
		height: 77px;
		width: 63px;
	}
	.game-rating__usk-kartrider-drift {
		background: url(../../images/game-rating/usk-0.png) no-repeat center center / contain;
		margin-top: 20px;
		height: 84px;
		width: 84px;
	}
	// .game-rating__acb-kartrider-drift {
	// 	background: url(../../images/game-rating/acb-g.png) no-repeat center center / contain;
	// 	margin-top: 20px;
	// 	height: 84px;
	// 	width: 84px;
	// }
}
@media (min-width: 1024px) {
	.game-rating {
		.game-rating__esrb-kartrider-drift {
			margin-top: 7px;
			height: 80px;
			width: 53px;
		}
		.game-rating__pegi-kartrider-drift {
			margin-top: 7px;
			height: 70px;
			width: 57px;
		}
		.game-rating__usk-kartrider-drift {
			margin-top: 7px;
			height: 78px;
			width: 78px;
		}
		// .game-rating__acb-kartrider-drift {
		// 	margin-top: 7px;
		// 	height: 78px;
		// 	width: 78px;
		// }
	}
}
@media (min-width: 1280px) {
	.game-rating {
		.game-rating__esrb-kartrider-drift {
			margin-top: 7px;
			height: 80px;
			width: 53px;
		}
		.game-rating__pegi-kartrider-drift {
			margin-top: 7px;
			height: 70px;
			width: 57px;
		}
		.game-rating__usk-kartrider-drift {
			margin-top: 7px;
			height: 78px;
			width: 78px;
		}
		// .game-rating__acb-kartrider-drift {
		// 	margin-top: 7px;
		// 	height: 78px;
		// 	width: 78px;
		// }
	}
}
@media (min-width: 1440px) {
	.game-rating {
		.game-rating__esrb-kartrider-drift {
			margin-top: 20px;
			height: 90px;
			width: 60px;
		}
		.game-rating__pegi-kartrider-drift {
			margin-top: 20px;
			height: 80px;
			width: 65px;
		}
		.game-rating__usk-kartrider-drift {
			margin-top: 20px;
			height: 86px;
			width: 86px;
		}
		// .game-rating__acb-kartrider-drift {
		// 	margin-top: 20px;
		// 	height: 86px;
		// 	width: 86px;
		// }
	}
}
@media (min-width: 1920px) {
	.game-rating {
		.game-rating__esrb-kartrider-drift {
			height: 100px;
			width: 66px;
		}
		.game-rating__pegi-kartrider-drift {
			height: 85px;
			width: 70px;
		}
		.game-rating__usk-kartrider-drift {
			height: 90px;
			width: 90px;
		}
		// .game-rating__acb-kartrider-drift {
		// 	height: 90px;
		// 	width: 90px;
		// }
	}
}
</style>
